import { useMutation } from "@tanstack/react-query";
import { useToast } from "#/hooks/ToastContext";
import {
  requestArticleAssetReview,
  type ArticleAssetReviewResponse,
} from "#/services/articles";

export function useArticleAssetReview() {
  const { showToast } = useToast();

  return useMutation<
    ArticleAssetReviewResponse,
    Error,
    { assetId: string; note?: string; basePrompt?: string }
  >({
    mutationFn: ({ assetId, note, basePrompt }) =>
      requestArticleAssetReview(assetId, { note, basePrompt }),
    onSuccess: (data) => {
      if (data.queuedUpdate?.newAssetId) {
        showToast(`Image update queued (${data.queuedUpdate.newAssetId}).`, "success");
        return;
      }
      showToast(data.notes || "Asset review queued for processing.", "success");
    },
    onError: (error) => {
      const message =
        error instanceof Error
          ? error.message
          : "Failed to request asset review.";
      showToast(message, "error");
    },
  });
}

export default useArticleAssetReview;
